@if (!isLoading) {
  <div class="row">
    <!-- Resource Accounts Tile -->
    @if (tileStates.resourceAccounts.isDisplayed) {
      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
        <ziro-service-tile
          [attr.data-automation]="tileStates.resourceAccounts.dataAutomation"
          [dataAutomation]="tileStates.resourceAccounts.dataAutomation"
          [serviceType]="tileStates.resourceAccounts.serviceType"
          [tileType]="tileStates.resourceAccounts.tileType"
          [serviceName]="tileStates.resourceAccounts.serviceName"
          [icon]="tileStates.resourceAccounts.icon"
          [description]="tileStates.resourceAccounts.description"
          [isInProgress]="false"
          [isDeleting]="tileStates.resourceAccounts.isDeleting"
          [isEnabled]="tileStates.resourceAccounts.isEnabled"
          [tooltip]="tileStates.resourceAccounts.tooltip"
          [isDeleteShown]="true"
          [isDeleteEnabled]="!microsoft360View.resourceAccountDetails?.associatedVoiceApplication"
          [deleteTooltip]="
            microsoft360View.resourceAccountDetails?.associatedVoiceApplication
              ? 'tkey;microsoft_360.resource_accounts.tile.delete.disabled.tooltip'
              : ''
          "
          (editTileClicked)="onEditTileClicked(tileStates.resourceAccounts)"
          (editTileDeleteClicked)="onEditTileDeleteClicked(tileStates.resourceAccounts)"
          (deleteTileConfirmButtonClicked)="onDeleteTileConfirmButtonClicked(tileStates.resourceAccounts)"
          (deleteTileCancelButtonClicked)="onDeleteTileCancelButtonClicked(tileStates.resourceAccounts)"
        ></ziro-service-tile>
      </div>
    }
    <!-- Security Group Memberships Tile -->
    @if (tileStates.msSecurityGroupMembership.isDisplayed) {
      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
        <ziro-service-tile
          [attr.data-automation]="tileStates.msSecurityGroupMembership.dataAutomation"
          [dataAutomation]="tileStates.msSecurityGroupMembership.dataAutomation"
          [serviceType]="tileStates.msSecurityGroupMembership.serviceType"
          [tileType]="tileStates.msSecurityGroupMembership.tileType"
          [serviceName]="tileStates.msSecurityGroupMembership.serviceName"
          [icon]="tileStates.msSecurityGroupMembership.icon"
          [description]="tileStates.msSecurityGroupMembership.description"
          [isInProgress]="false"
          [isDeleting]="tileStates.msSecurityGroupMembership.isDeleting"
          [isEnabled]="tileStates.msSecurityGroupMembership.isEnabled"
          [tooltip]="tileStates.msSecurityGroupMembership.tooltip"
          [isDeleteShown]="tileConfig.groups === TileStatus.SHOW_WITH_DELETE"
          [isDeleteEnabled]="true"
          (addTileClicked)="onAddTileClicked(tileStates.msSecurityGroupMembership)"
          (editTileClicked)="onEditTileClicked(tileStates.msSecurityGroupMembership)"
          (editTileDeleteClicked)="onEditTileDeleteClicked(tileStates.msSecurityGroupMembership)"
          (deleteTileConfirmButtonClicked)="onDeleteTileConfirmButtonClicked(tileStates.msSecurityGroupMembership)"
          (deleteTileCancelButtonClicked)="onDeleteTileCancelButtonClicked(tileStates.msSecurityGroupMembership)"
        ></ziro-service-tile>
      </div>
    }
    <!--MS Licensing Tile -->
    @if (tileStates.ms365.isDisplayed) {
      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
        <ziro-service-tile
          [attr.data-automation]="tileStates.ms365.dataAutomation"
          [dataAutomation]="tileStates.ms365.dataAutomation"
          [serviceType]="tileStates.ms365.serviceType"
          [tileType]="tileStates.ms365.tileType"
          [serviceName]="tileStates.ms365.serviceName"
          [icon]="tileStates.ms365.icon"
          [description]="tileStates.ms365.description"
          [isAdding]="tileStates.ms365.isAdding"
          [isDeleting]="tileStates.ms365.isDeleting"
          [isEnabled]="tileStates.ms365.isEnabled"
          [isInProgress]="is365LicensesSyncInProgress"
          [isInProgressBadgeText]="tile365LicensesSyncBadgeText"
          [isDeleteShown]="tileConfig.license === TileStatus.SHOW_WITH_DELETE"
          [tooltip]="tileStates.ms365.tooltip"
          (addTileClicked)="onAddTileClicked(tileStates.ms365)"
          (editTileClicked)="onEditTileClicked(tileStates.ms365)"
          (editTileDeleteClicked)="onEditTileDeleteClicked(tileStates.ms365)"
          (deleteTileConfirmButtonClicked)="onDeleteTileConfirmButtonClicked(tileStates.ms365)"
          (deleteTileCancelButtonClicked)="onDeleteTileCancelButtonClicked(tileStates.ms365)"
        ></ziro-service-tile>
      </div>
    }
    <!--MS Teams Calling Tile -->
    @if (tileStates.msTeamsCalling.isDisplayed) {
      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
        <ziro-service-tile
          [attr.data-automation]="tileStates.msTeamsCalling.dataAutomation"
          [dataAutomation]="tileStates.msTeamsCalling.dataAutomation"
          [serviceType]="tileStates.msTeamsCalling.serviceType"
          [tileType]="tileStates.msTeamsCalling.tileType"
          [serviceName]="tileStates.msTeamsCalling.serviceName"
          [icon]="tileStates.msTeamsCalling.icon"
          [description]="tileStates.msTeamsCalling.description"
          [isInProgress]="isTeamsLicensingInProgress"
          [isDeleting]="tileStates.msTeamsCalling.isDeleting"
          [isEnabled]="tileStates.msTeamsCalling.isEnabled"
          [isDeleteShown]="tileConfig.calling === TileStatus.SHOW_WITH_DELETE"
          [isImmediateCallForwardingEnabled]="tileStates.msTeamsCalling.isImmediateCallForwarding"
          [tooltip]="tileStates.msTeamsCalling.tooltip"
          [immediateCallForwardingTooltip]="tileStates.msTeamsCalling.immediateCallForwardingTooltip"
          (addTileClicked)="onAddTileClicked(tileStates.msTeamsCalling)"
          (editTileClicked)="onEditTileClicked(tileStates.msTeamsCalling)"
          (editTileDeleteClicked)="onEditTileDeleteClicked(tileStates.msTeamsCalling)"
          (deleteTileConfirmButtonClicked)="onDeleteTileConfirmButtonClicked(tileStates.msTeamsCalling)"
          (deleteTileCancelButtonClicked)="onDeleteTileCancelButtonClicked(tileStates.msTeamsCalling)"
        ></ziro-service-tile>
      </div>
    }
    <!--MS Audio Conferencing Tile -->
    @if (tileStates.msTeamsAudioConferencing.isDisplayed) {
      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
        <ziro-service-tile
          [attr.data-automation]="tileStates.msTeamsAudioConferencing.dataAutomation"
          [dataAutomation]="tileStates.msTeamsAudioConferencing.dataAutomation"
          [serviceType]="tileStates.msTeamsAudioConferencing.serviceType"
          [tileType]="tileStates.msTeamsAudioConferencing.tileType"
          [serviceName]="tileStates.msTeamsAudioConferencing.serviceName"
          [icon]="tileStates.msTeamsAudioConferencing.icon"
          [description]="tileStates.msTeamsAudioConferencing.description"
          [isInProgress]="isAudioLicensingInProgress"
          [isDeleting]="tileStates.msTeamsAudioConferencing.isDeleting"
          [isEnabled]="tileStates.msTeamsAudioConferencing.isEnabled"
          [isDeleteShown]="tileConfig.meeting === TileStatus.SHOW_WITH_DELETE"
          [tooltip]="tileStates.msTeamsAudioConferencing.tooltip"
          [isDeleteEnabled]="false"
          [deleteTooltip]="'tkey;shared.model.ms_teams_audio_conferencing.tile.delete.tooltip'"
          [showWarning]="hasAudioConferenceMismatch"
          [warningTooltip]="'tkey;microsoft_360.view.audio_conferencing.location_mismatch.tooltip'"
          (addTileClicked)="onAddTileClicked(tileStates.msTeamsAudioConferencing)"
          (editTileClicked)="onEditTileClicked(tileStates.msTeamsAudioConferencing)"
          (editTileDeleteClicked)="onEditTileDeleteClicked(tileStates.msTeamsAudioConferencing)"
          (deleteTileConfirmButtonClicked)="onDeleteTileConfirmButtonClicked(tileStates.msTeamsAudioConferencing)"
          (deleteTileCancelButtonClicked)="onDeleteTileCancelButtonClicked(tileStates.msTeamsAudioConferencing)"
        ></ziro-service-tile>
      </div>
    }
    <!--Dubber Tile -->
    @if (tileStates.dubber.isDisplayed) {
      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
        <ziro-service-tile
          [attr.data-automation]="tileStates.dubber.dataAutomation"
          [dataAutomation]="tileStates.dubber.dataAutomation"
          [serviceType]="tileStates.dubber.serviceType"
          [tileType]="tileStates.dubber.tileType"
          [serviceName]="tileStates.dubber.serviceName"
          [icon]="tileStates.dubber.icon"
          [description]="tileStates.dubber.description"
          [isDeleting]="tileStates.dubber.isDeleting"
          [isEnabled]="tileStates.dubber.isEnabled"
          [isDeleteShown]="tileConfig.dubber === TileStatus.SHOW_WITH_DELETE"
          [isDeleteEnabled]="true"
          (addTileClicked)="onAddTileClicked(tileStates.dubber)"
          (editTileClicked)="onEditTileClicked(tileStates.dubber)"
          (editTileDeleteClicked)="onEditTileDeleteClicked(tileStates.dubber)"
          (deleteTileConfirmButtonClicked)="onDeleteTileConfirmButtonClicked(tileStates.dubber)"
          (deleteTileCancelButtonClicked)="onDeleteTileCancelButtonClicked(tileStates.dubber)"
        ></ziro-service-tile>
      </div>
    }

    @if (tileStates.callQueues.isDisplayed) {
      <!-- Call Queues Tile -->
      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
        <ziro-service-tile
          [attr.data-automation]="tileStates.callQueues.dataAutomation"
          [dataAutomation]="tileStates.callQueues.dataAutomation"
          [serviceType]="tileStates.callQueues.serviceType"
          [tileType]="tileStates.callQueues.tileType"
          [serviceName]="tileStates.callQueues.serviceName"
          [icon]="tileStates.callQueues.icon"
          [description]="tileStates.callQueues.description"
          [isInProgress]="false"
          [isDeleting]="tileStates.callQueues.isDeleting"
          [isEnabled]="tileStates.callQueues.isEnabled"
          [tooltip]="tileStates.callQueues.tooltip"
          [isDeleteShown]="true"
          [isDeleteEnabled]="true"
          (addTileClicked)="onAddTileClicked(tileStates.callQueues)"
          (editTileClicked)="onEditTileClicked(tileStates.callQueues)"
          (editTileDeleteClicked)="onEditTileDeleteClicked(tileStates.callQueues)"
          (deleteTileConfirmButtonClicked)="onDeleteTileConfirmButtonClicked(tileStates.callQueues)"
          (deleteTileCancelButtonClicked)="onDeleteTileCancelButtonClicked(tileStates.callQueues)"
        ></ziro-service-tile>
      </div>
    }

    @if (tileStates.autoAttendants.isDisplayed) {
      <!-- Auto Attendants Tile -->
      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
        <ziro-service-tile
          [attr.data-automation]="tileStates.autoAttendants.dataAutomation"
          [dataAutomation]="tileStates.autoAttendants.dataAutomation"
          [serviceType]="tileStates.autoAttendants.serviceType"
          [tileType]="tileStates.autoAttendants.tileType"
          [serviceName]="tileStates.autoAttendants.serviceName"
          [icon]="tileStates.autoAttendants.icon"
          [description]="tileStates.autoAttendants.description"
          [isInProgress]="false"
          [isDeleting]="tileStates.autoAttendants.isDeleting"
          [isEnabled]="tileStates.autoAttendants.isEnabled"
          [tooltip]="tileStates.autoAttendants.tooltip"
          [isDeleteShown]="false"
          [isDeleteEnabled]="false"
          [isBeta]="true"
          (addTileClicked)="onAddTileClicked(tileStates.autoAttendants)"
          (editTileClicked)="onEditTileClicked(tileStates.autoAttendants)"
          (editTileDeleteClicked)="onEditTileDeleteClicked(tileStates.autoAttendants)"
          (deleteTileConfirmButtonClicked)="onDeleteTileConfirmButtonClicked(tileStates.autoAttendants)"
          (deleteTileCancelButtonClicked)="onDeleteTileCancelButtonClicked(tileStates.autoAttendants)"
        ></ziro-service-tile>
      </div>
    }

    @if (devices.length) {
      @for (device of devices; track device; let i = $index) {
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
          <ziro-service-tile
            [attr.data-automation]="'device-tile-' + i"
            [tileType]="ServiceTileType.EDIT"
            [isDevice]="true"
            [serviceName]="device.manufacturer[0].toUpperCase() + device.manufacturer.slice(1)"
            [description]="device.model.toUpperCase()"
            [icon]="
              device.deviceType === 'ipPhone' || device.deviceType === 'lowCostPhone' || device.deviceType === 'sip'
                ? ziroIcons.PHONE_DIAL
                : ziroIcons.MONITOR
            "
            [isDeleteEnabled]="false"
            [isDeleteShown]="false"
            [deviceToolip]="device.tooltip"
            [deviceIconMarkup]="device.iconMarkup"
          ></ziro-service-tile>
        </div>
      }
    }
  </div>
}
